module.exports = __webpack_public_path__ + "img/wallet-airdrop.3a3fe8c4.svg";